import React from "react";

function Footer() {
  return (
    <div id="footer">
      <span>by</span>
      <a rel="noopener noreferrer" href="https://github.com/loarsaw">
        😺loarsaw😺
      </a>
    </div>
  );
}

export default Footer;
